import FlexExample from "../../../../content/blog/center-elements-using-flexbox/example.tsx";
import * as React from 'react';
export default {
  FlexExample,
  React
};